import { successNotification } from 'components/successNotification/successNotification';

export const isEmptyArray = (array: [], func: any, name: string) => {
  if (Array.isArray(array) && array?.length) {
    func();
  } else {
    successNotification(`${name} was not found!`);
  }
};
